import type { PropertySelectionRow } from "../../types";

/**
 * 新しいIDを生成する
 * @param properties プロパティ配列
 * @returns 新しいID
 */
export const generateNextId = (properties: PropertySelectionRow[]): number => {
  return properties.length > 0
    ? Math.max(...properties.map((p) => p.id)) + 1
    : 1;
};
